import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-movie-2-line text-background-50 text-lg"></i>
            </span>
            <span className={`font-heading text-xl font-bold whitespace-nowrap ${scrolled || !isHome ? 'text-foreground-900' : 'text-white'}`}>
              农民影视
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'bg-primary-500 text-background-50'
                  : scrolled || !isHome
                    ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                    : 'text-white/90 hover:text-white hover:bg-white/10'
              }`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors flex items-center gap-1 whitespace-nowrap ${
                  location.pathname.startsWith('/category')
                    ? 'bg-primary-500 text-background-50'
                    : scrolled || !isHome
                      ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                      : 'text-white/90 hover:text-white hover:bg-white/10'
                }`}
              >
                分类浏览
                <i className={`ri-arrow-down-s-line text-sm transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {categoryOpen && (
                <div className="absolute top-full mt-2 left-0 w-48 bg-background-50 rounded-xl border border-background-200/80 shadow-lg py-2 animate-[fadeIn_0.15s_ease-out]">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap"
                    >
                      <span className="w-6 h-6 flex items-center justify-center">
                        <i className={`${cat.icon} text-base`}></i>
                      </span>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'bg-primary-500 text-background-50'
                  : scrolled || !isHome
                    ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                    : 'text-white/90 hover:text-white hover:bg-white/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className={`relative ${scrolled || !isHome ? '' : 'hidden'}`}>
              <input
                type="text"
                placeholder="搜索影片..."
                className="w-48 pl-9 pr-3 py-2 text-sm rounded-lg bg-background-100 border border-background-200 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg ${
              scrolled || !isHome ? 'text-foreground-800' : 'text-white'
            }`}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 animate-[fadeIn_0.2s_ease-out]">
          <div className="px-4 py-4 space-y-1">
            <Link to="/" className="block px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg transition-colors">
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-3 px-4 py-3 text-sm text-foreground-700 hover:bg-background-100 rounded-lg transition-colors"
              >
                <span className="w-6 h-6 flex items-center justify-center">
                  <i className={`${cat.icon} text-base`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="block px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg transition-colors">
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}